export const allowedDomains: string[] = ["teamscx.com","infodation.nl","infodation.vn","scb-global.com","macdeesolutions.com"] //plain text
